const template = document.createElement('template')
template.innerHTML = `
<style>
:host {
    --gap: var(--slider-gap, 20px);
    --items: var(--slider-items, 3);
    --min-item-size: var(--slider-min-item-size, 300px);
    --max-item-size: var(--slider-max-item-size, 10000px);

    position: relative;
    display: flex;
}

.wrap-list {
    display: flex;
    overflow: hidden;
}

.list::-webkit-scrollbar { /* hide scrollbar webkit */
    display: none;
}

.list {
    display: flex;
    gap: var(--gap);
    /* align-items: center; */
    margin-inline: auto;
    padding-inline: 1px; /* fix intersectionObserver */
    /* justify-content: safe center; */

    overflow: auto hidden;
    /* touch-action: pan-x; */
    user-select: none;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    /* prevent scroll chaining on x scroll */
    overscroll-behavior-x: contain;
    scrollbar-width: none; /* hide scrollbar firefox */
}

::slotted([slot="item"].first) {
    margin-left: auto;
}
::slotted([slot="item"].last) {
    margin-right: auto;
}

::slotted([slot="item"]) {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: min(
        var(--max-item-size),
        max(
            var(--min-item-size),
            calc((100% - (var(--items) - 1) * var(--gap)) / var(--items))
        )
    );
}

.controls {
}

</style>

<div class="wrap-list">
    <div class="list">
        <slot name="item"></slot>
    </div>
</div>
<slot name="controls"></slot>
`

customElements.define(
	'vp-slider',
	class extends HTMLDivElement {
		constructor() {
			super()

			this.attachShadow({ mode: 'open' })
			const clone = template.content.cloneNode(true)
			this.shadowRoot.appendChild(clone)
			this.dom = {}
			this.scrolling = false
		}

		connectedCallback() {
			this.dom.list = this.shadowRoot.querySelector('.list')
			this.dom.items = this.shadowRoot.querySelector('slot[name=item]').assignedElements()
			this.hasItems = !!this.dom.items.length
			this.dom.first = this.first()
			this.dom.last = this.last()
			this.dom.controls = this.shadowRoot.querySelector('slot[name="controls"]').assignedElements()[0] ?? null
			this.dom.prev = this.dom.controls?.querySelector('.prev')
			this.dom.next = this.dom.controls?.querySelector('.next')

			this.dom.controls?.addEventListener('click', (e) => {
				const target = e.target.closest('.prev,.next')
				if (!target) return
				if (target.classList.contains('prev')) this.prev()
				if (target.classList.contains('next')) this.next()
			})

			const io = new IntersectionObserver(
				(observed) => {
					for (const obs of observed) {
						if (obs.isIntersecting) {
							this.current = Array.from(this.dom.items).indexOf(obs.target)
							this.dispatchEvent(
								new CustomEvent('change', {
									detail: { index: this.current },
								}),
							)
						}
						if (obs.target === this.dom.first) {
							this.dom.prev?.classList.toggle('disabled', obs.isIntersecting)
						}
						if (obs.target === this.dom.last) {
							this.dom.next?.classList.toggle('disabled', obs.isIntersecting)
						}
					}
					this.dom.controls?.classList.toggle(
						'hidden',
						this.dom.prev?.classList.contains('disabled') && this.dom.next?.classList.contains('disabled'),
					)
				},
				{
					root: this.dom.list,
					threshold: 0.6,
				},
			)
			if (this.dom.first) {
				this.dom.first.classList.add('first')
			}
			if (this.dom.last) {
				this.dom.last.classList.add('last')
			}
			for (const el of this.dom.items) io.observe(el)

			this.goTo(this.dom.first)
		}

		// slide to previous element
		prev() {
			if (this.dom.list.scrollLeft <= 0) {
				// console.log('scroll min');
			} else {
				const current = this.current
				const element = current > 0 ? this.dom.items[current - 1] : null
				if (element && !this.scrolling) this.goTo(element)
			}
		}

		// slide to next element
		next() {
			if (this.dom.list.scrollLeft + this.dom.list.offsetWidth >= this.dom.list.scrollWidth) {
				// console.log('scroll max');
			} else {
				const current = this.current
				const element = current < this.dom.items.length ? this.dom.items[current + 1] : null
				if (element && !this.scrolling) this.goTo(element)
			}
		}

		// return first element in list
		first() {
			return this.hasItems ? this.dom.items[0] : null
		}

		// return last element in list
		last() {
			return this.hasItems ? this.dom.items[this.dom.items.length - 1] : null
		}

		// slide to element
		goTo(element) {
			const el = Number.isInteger(element) ? this.dom.items[element] : element
			if (!el) {
				return
			}
			if (this.scrolling !== null) {
				clearTimeout(this.scrolling)
			}
			this.scrolling = setTimeout(() => {
				this.scrolling = null
			}, 500)
			this.dom.list.scrollTo({
				top: 0,
				left: el.offsetLeft,
				behavior: 'smooth',
			})
		}
	},
	{ extends: 'div' },
)
